import type { LOAN_REQUEST_COMMAND } from 'cpool-constants';

import { generateDiffIncome, type LeafObject } from './compareIncome';
import objectKeys from '~/utils/objectKeys';

export type CollectionCommandConfig = {
    addCommand: LOAN_REQUEST_COMMAND;
    changeCommand: LOAN_REQUEST_COMMAND;
    removeCommand: LOAN_REQUEST_COMMAND;
};

type CollectionCommand = { commandName: string; payload: Record<string, unknown> };

export function generateCollectionCommands<TType extends string>(
    oldData: Record<TType, LeafObject[]> | undefined,
    newData: Record<TType, LeafObject[]>,
    typeConfig: Record<TType, CollectionCommandConfig>,
    mapRemovePayload: (item: LeafObject) => Record<string, unknown> = (item) => item,
): CollectionCommand[] {
    const commands: CollectionCommand[] = [];

    if (oldData === undefined) {
        objectKeys(newData).forEach((key) => {
            newData[key].forEach((item) => {
                commands.push({ commandName: typeConfig[key].addCommand, payload: item });
            });
        });
        return commands;
    }

    const diff = generateDiffIncome(oldData, newData);
    objectKeys(diff).forEach((change) => {
        objectKeys(diff[change]).forEach((key) => {
            const config = typeConfig[key as TType];
            if (!config) {
                throw new Error(`Unknown key: ${key}`);
            }
            const commandNameByChange = {
                added: config.addCommand,
                modified: config.changeCommand,
                removed: config.removeCommand,
            };
            const commandName = commandNameByChange[change];
            diff[change][key].forEach((item) => {
                commands.push({
                    commandName,
                    payload: change === 'removed' ? mapRemovePayload(item) : item,
                });
            });
        });
    });

    return commands;
}
